import React from "react";
import { PhoneCall, Repeat, Sparkles } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: PhoneCall,
    title: "Book a free call",
    desc: "Tell us about your business in a relaxed 20-minute chat. No sales script, no pressure.",
  },
  {
    n: "02",
    icon: Repeat,
    title: "We handle the handover",
    desc: "We speak to your old accountant, get HMRC authorisations, and migrate your data — all on us.",
  },
  {
    n: "03",
    icon: Sparkles,
    title: "Relax — we’ve got it",
    desc: "Deadlines tracked. Tax planned. Questions answered within hours, not weeks.",
  },
];

export const HowItWorks = () => (
  <section
    data-testid="how-it-works-section"
    className="bg-[#EAF4DD] py-20 md:py-28"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <p className="text-xs uppercase tracking-[0.2em] text-[#C57A5A] font-medium">
          How it works
        </p>
        <h2 className="font-serif-display mt-3 text-3xl sm:text-4xl md:text-5xl text-[#2A3430] leading-tight">
          From first call to fully sorted in days.
        </h2>
      </div>

      <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8">
        {steps.map(({ n, icon: Icon, title, desc }) => (
          <div
            key={n}
            data-testid={`step-card-${n}`}
            className="relative bg-white border border-[#2A3430]/10 rounded-3xl p-8 overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#C57A5A]/10 hover:border-[#C57A5A]/40"
          >
            <span className="font-serif-display absolute -top-4 -right-2 text-[8rem] leading-none text-[#F5EEE9] select-none pointer-events-none">
              {n}
            </span>
            <div className="relative">
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#C57A5A] text-white">
                <Icon className="h-5 w-5" strokeWidth={1.75} />
              </span>
              <h3 className="font-serif-display mt-5 text-2xl text-[#2A3430]">
                {title}
              </h3>
              <p className="mt-2 text-sm text-[#2A3430]/80 leading-relaxed">
                {desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
